export default function BackgroundImage() {
  return(
    <>
      <img      
        src="/images/aboveTheFoldBrowser.webp"
        alt="Desktop hero"
        className="above-the-fold-img desktop-only"
      />

      <img      
        src="/images/aboveTheFoldMobile.webp"
        alt="Mobile hero"
        className="above-the-fold-img mobile-only"
      />
    </>
  )
}